import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useMechanicAuth } from '../../context/MechanicAuthContext';
import { getMechanicJobs } from '../../api/mechanicAuth.api';
import '../../styles/mechanic.css';

const isSameMonth = (dateStr) => {
  const d = new Date(dateStr);
  const now = new Date();
  return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
};

const MechanicEarnings = () => {
  const { mechanic, logoutMechanic } = useMechanicAuth();
  const [completedJobs, setCompletedJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMechanicJobs({ status: 'completed', limit: 100 })
      .then((data) => setCompletedJobs(data.requests || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const completedThisMonth = completedJobs.filter((j) => isSameMonth(j.updatedAt || j.createdAt)).length;

  return (
    <div className="mechanic-page">
      <div className="mechanic-container">
        <div className="mechanic-header">
          <div>
            <h1 className="mechanic-title">Earnings</h1>
            <p className="mechanic-subtitle">Mechanic Portal — RJ Road Assist</p>
          </div>
          <button className="mechanic-logout-btn" onClick={logoutMechanic}>Logout</button>
        </div>

        <div className="mechanic-empty" style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
          <p>
            Online payments aren't live yet, so this page shows completed-job counts, not payout amounts.
            Payout/₹ tracking will be added here once the payment gateway is integrated.
          </p>
        </div>

        <div className="mechanic-stats">
          <div className="mechanic-stat-card blue">
            <div className="mechanic-stat-val">{completedJobs.length}</div>
            <div className="mechanic-stat-label">Total Completed Jobs</div>
          </div>
          <div className="mechanic-stat-card green">
            <div className="mechanic-stat-val">{completedThisMonth}</div>
            <div className="mechanic-stat-label">Completed This Month</div>
          </div>
          <div className="mechanic-stat-card purple">
            <div className="mechanic-stat-val">{parseFloat(mechanic?.rating || 5).toFixed(1)}</div>
            <div className="mechanic-stat-label">Rating</div>
          </div>
        </div>

        <div className="mechanic-quick-links">
          <Link to="/mechanic/dashboard" className="mechanic-quick-link">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Dashboard
          </Link>
          <Link to="/mechanic/jobs" className="mechanic-quick-link">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            My Jobs
          </Link>
          <Link to="/mechanic/notifications" className="mechanic-quick-link">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            Notifications
          </Link>
          <Link to="/mechanic/profile" className="mechanic-quick-link">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            My Profile
          </Link>
        </div>

        <h3 className="mechanic-section-title">Completed Jobs</h3>

        {loading ? (
          <div className="mechanic-loading"><div className="auth-spinner" /></div>
        ) : completedJobs.length === 0 ? (
          <div className="mechanic-empty">
            <p>No completed jobs yet.</p>
          </div>
        ) : (
          <div className="mechanic-job-list">
            {completedJobs.slice(0, 20).map((job) => (
              <div key={job.id} className="mechanic-job-card">
                <div className="mechanic-job-info">
                  <div className="mechanic-job-tracking">{job.trackingId}</div>
                  <div className="mechanic-job-customer">{job.customerName}</div>
                  <div className="mechanic-job-service">{job.serviceName || job.service?.name || 'Service'}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MechanicEarnings;
